<template>
  <div class="modal fade show d-block" id="ViewInvoiceModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('modal.viewModal.title') }}</h5>
          <button type="button" class="btn-close" @click="$emit('close')" aria-label="Close"></button>
        </div>
        <div class="modal-body p-0" style="height:78vh;">
          <!-- Use an iframe to isolate CSS and JS from invoiceHtml -->
          <iframe ref="invoiceIframe" style="width:100%; height:100%; border:none;"></iframe>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">{{ $t('modal.viewModal.close') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    invoiceHtml: {
      type: String,
      default: ''
    }
  },
  watch: {
    invoiceHtml(newHtml) {
      this.renderHtmlToIframe(newHtml);
    }
  },
  mounted() {
    // If invoiceHtml is already available when mounted, render it
    if (this.invoiceHtml) {
      this.renderHtmlToIframe(this.invoiceHtml);
    }
  },
  methods: {
    renderHtmlToIframe(htmlContent) {
      const iframe = this.$refs.invoiceIframe;
      if (!iframe) return;

      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(htmlContent);
      iframeDoc.close();
    }
  }
}
</script>

<style scoped>
/* Modal-specific styles if needed */
</style>
